module.exports = __webpack_public_path__ + "img/NL6278707.c8a99153.png";